import { renderPage } from "renderPage"
import { ClubProductShowPage } from "./Page"

renderPage({ component: ClubProductShowPage })
